import { homeColors, media, pageTitle } from '../../tokens'

const styles = () => ({
  heading: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  title: {
    ...pageTitle,
    textWrap: 'pretty',
  },
  subtitleRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '16px',
  },
  subtitle: {
    fontSize: '15px',
    color: homeColors.muted,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: '16px',
    [media.tablet]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [media.phone]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
})

export default styles
